import React, { useState, useEffect } from 'react';
import GoalTable from './GoalTable';
import PrevMonthBudgetTable from './PrevMonthBudgetTable';
import { getSocietes } from '../../flux/actions/societeActions';
import { clearGoals, getGoalsByProject } from '../../flux/actions/goalActions';
import { getGoal_societe_defaults } from '../../flux/actions/goalsocietedefaultActions';
import { getBudgets } from '../../flux/actions/budgetActions';
import { getUsersWhoWorksAt } from '../../flux/actions/userActions';
import { getSummaryProjectBudget, clearVentes } from '../../flux/actions/venteActions';
import { getSummaryProjectAssociationsBudget, clearAssociations } from '../../flux/actions/associationActions';
import { getSummaryProjectBudgetEnc, clearEncaissements } from '../../flux/actions/encaissementActions';
import { Container, Row, Col, Label } from 'reactstrap';

import { connect } from 'react-redux';
import { IGoalContainer, IGoalReduxProps } from '../../types/interfaces';
import Select from 'react-select';
import LoadingPage from '../../pages/loading';
import { constants } from '../../types/constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faBoxOpen, faUsers, faDesktop, faBullseye, faCaretLeft, faCaretRight, faCalendarAlt, faHistory, faEdit } from '@fortawesome/free-solid-svg-icons'
import Loading from '../Loading';
import MonthPicker from 'react-month-picker'
import { PRIVILEGE } from '../../types/privileges';
import moment from 'moment';

const GoalContainerComponent = ({
  getGoalsByProject,
  clearGoals,
  goal,
  getGoal_societe_defaults,
  goal_societe_default,
  getBudgets,
  budget,
  getSocietes,
  societe,
  getSummaryProjectBudget,
  clearVentes,
  getSummaryProjectAssociationsBudget,
  clearAssociations,
  getSummaryProjectBudgetEnc,
  clearEncaissements,
  vente,
  association,
  encaissement,
  auth
 }: IGoalContainer) => {

  const { goals, loading: loadingG } = goal;
  const { goal_societe_defaults, loading: loadingGSD } = goal_societe_default;
  const { budgets, loading: loadingB } = budget;
  const { societes, loading: loadingS } = societe;
  const { ventes, loading } = vente;
  const { associations, loading: loadingA } = association;
  const { encaissements, loading: loadingE } = encaissement;
  const [ventesAndAssociations, setVentesAndAssociations] = useState<any[]>([])
  const [tableData2, setTableData2] = useState<any[]>([]);
  const [tableData, setTableData] = useState<any[]>([]);
  const societeOptions = societes.map(e => ({value: e, label: e.LIBELE}));
  const [societeValue, setSocieteValue] = useState<any>('');
  const today = new Date();
  const [monthPickerValue, setMonthPickerValue] = useState({ year: today.getFullYear(), month: today.getMonth() + 1 });
  const monthPickerRef = React.useRef<any>(null);
  const [users, setUsers] = useState<any[]>([]);
  const [usersLoading, setUsersLoading] = useState(false);
  const [showUsers, setShowUsers] = useState(false);
  
  useEffect(() => {
    clearGoals()
    if(societeValue)
      getGoalsByProject(societeValue?.id);
  }, [getGoalsByProject, societeValue]);
  
  useEffect(() => {
    getGoal_societe_defaults();
  }, [getGoal_societe_defaults]);
  
  useEffect(() => {
    getBudgets();
  }, [getBudgets]);

  useEffect(() => {
    getSummaryProjectBudget(1)
  }, [getSummaryProjectBudget]);

  useEffect(() => {
    getSummaryProjectAssociationsBudget()
  }, [getSummaryProjectAssociationsBudget]);

  useEffect(() => {
    getSummaryProjectBudgetEnc()
  }, [getSummaryProjectBudgetEnc]);

  useEffect(() => {
    return () => {
      clearVentes();
      clearAssociations();
      clearEncaissements();
    }
  }, []);

  useEffect(() => {
    setVentesAndAssociations([...ventes, ...associations.map(e => ({...e, vente: e.contrat, isAssLine: true}))]
    .sort((a, b) => {
      if(!a.createdAt && !b.createdAt)
        return 0
      else if(!a.createdAt)
        return 1
      else if(!b.createdAt)
        return -1
      else
        return a.createdAt > b.createdAt ? -1 : a.createdAt < b.createdAt ? 1 : 0
    }))
  }, [ventes, associations]);
  
  useEffect(() => {
    if(societeValue){
      setUsersLoading(true)
      getUsersWhoWorksAt(societeValue.id).then(e => setUsers(e))
      .catch(e => setUsers([]))
      .finally(() => setUsersLoading(false))
    }
    else
      setUsers([])
  }, [societeValue]);

  useEffect(() => {
    auth && auth.user && getSocietes(auth?.user.societes?.map(e => e.id) || []/*, !!auth.user.privileges?.includes(PRIVILEGE.FULL_MENU)*/);
  }, [getSocietes, auth]);

  useEffect(() => {
    if(!societeValue && societes && societes.length){
      if(auth && auth.user){
        for(let so of societes)
          if(so.id == auth.user.last_societe){
            setSocieteValue(so);
            break
          }
      }
    }
  }, [societes]);

  useEffect(() => console.log(societes, users), [societes, users])

  const getVentesFromMonth = (ventesAndAssociations, month, year) => {
    return ventesAndAssociations.filter(e => {
      const createdAt = e.isAssLine ? e.originalDate : e.DATE_RESERV;
      return createdAt && (new Date(createdAt).getMonth() + 1) === month && (new Date(createdAt).getFullYear()) === year
    })
  }

  const getEncaissementsFromMonth = (encaissements, month, year) => {
    return encaissements.filter(e => {
      const createdAt = e.createdAt;
      return createdAt && (new Date(createdAt).getMonth() + 1) === month && (new Date(createdAt).getFullYear()) === year
    })
  }

  const getLivraisonsFromMonth = (ventesAndAssociations, month, year) => {
    return ventesAndAssociations.filter(e => (e.isAssLine ? e.contrat : e)?.bien?.STATUT === constants.STATUT_SIGNE_NOTAIRE || (e.isAssLine ? e.contrat : e)?.en_cours_signature == 1 || (e.isAssLine ? e.contrat : e)?.chez_notaire == 1).filter(e => {
      const dates = [(e.isAssLine ? e.contrat : e)?.chez_notaire == 1 && (e.isAssLine ? e.contrat : e)?.chez_notaire_date, (e.isAssLine ? e.contrat : e)?.en_cours_signature == 1 && (e.isAssLine ? e.contrat : e)?.en_cours_signature_date, (e.isAssLine ? e.contrat : e)?.bien?.STATUT === constants.STATUT_SIGNE_NOTAIRE && (e.isAssLine ? e.contrat : e)?.bien?.signe_notaire_date].filter(e => !!e)
      const signedAt = dates.length > 0 ? moment.min(dates.map(e => moment(e))).toDate() : undefined;
      return signedAt && (new Date(signedAt).getMonth() + 1) === month && (new Date(signedAt).getFullYear()) === year
    })//.filter((e, i, a) => !e.isAssLine || i === 0 || a.findIndex(t => t.contrat?.id === e.contrat?.id) === i)
  }

  const getGoalsFromDateProjUser = (userId: number, societeId: any, month: number, year: number) => {
    let res: any = goals.find(e => e.comId === userId && e.societeId === societeId && e.month === month && e.year === year);
    if(!res)
      res = goal_societe_defaults.find(e => e.societeId === societeId && e.month === month && e.year === year)
    
    return res
  }

  useEffect(() => {
    setTableData([
      ...(!!auth?.user?.privileges?.includes(PRIVILEGE.EDIT_BUDGETS) ? [{
        name: "Objectif Budget",
        isBudget: true,
        ...budgets.find(e => e.month === monthPickerValue?.month && e.year === monthPickerValue?.year && e.societeId === societeValue?.id),
        month: monthPickerValue?.month,
        year: monthPickerValue?.year,
      }] : []),
      ...(!!auth?.user?.privileges?.includes(PRIVILEGE.EDIT_GOALS) ? [{
        name: "Objectif Commercial",
        showHideUsers: societeValue?.id !== "ALL",
        goalV: users.reduce((e, t) => e + (getGoalsFromDateProjUser(t.id, societeValue?.id, monthPickerValue?.month, monthPickerValue?.year)?.goalV || 0), 0),
        goalE: users.reduce((e, t) => e + (getGoalsFromDateProjUser(t.id, societeValue?.id, monthPickerValue?.month, monthPickerValue?.year)?.goalE || 0), 0),
        goalR: users.reduce((e, t) => e + (getGoalsFromDateProjUser(t.id, societeValue?.id, monthPickerValue?.month, monthPickerValue?.year)?.goalR || 0), 0),
        goalL: users.reduce((e, t) => e + (getGoalsFromDateProjUser(t.id, societeValue?.id, monthPickerValue?.month, monthPickerValue?.year)?.goalL || 0), 0),
        usersWithNoGoal: users.filter(e => !getGoalsFromDateProjUser(e.id, societeValue?.id, monthPickerValue?.month, monthPickerValue?.year)),
        month: monthPickerValue?.month,
        year: monthPickerValue?.year,
      },
      ...(showUsers && societeValue?.id !== "ALL" ? users.map(u => ({
        isUser: true,
        name: u.LOGIN,
        user: u,
        ...getGoalsFromDateProjUser(u.id, societeValue?.id, monthPickerValue?.month, monthPickerValue?.year),
        month: monthPickerValue?.month,
        year: monthPickerValue?.year,
      })) : [])] : []),
    ])
  }, [budgets, goals, goal_societe_defaults, monthPickerValue, users, showUsers])

  useEffect(() => {
    const previousMonth = Number(monthPickerValue?.month || -1) - 1
    let res: any[] = []
    if(previousMonth > 0){
      res = [{
        month: `${constants.DP_MONTHS[previousMonth - 1]} ${monthPickerValue?.year}`,
        sPrixNet: getVentesFromMonth(ventesAndAssociations.filter(t => (t.isAssLine ? t.contrat : t)?.IDPROJET === societeValue?.id), previousMonth, monthPickerValue?.year).reduce((e, t) => e + Number((t.isAssLine ? t.PRIX_VENTE : t.PRIX_NET) || 0), 0),
        sEncaissements: getEncaissementsFromMonth(encaissements.filter(t => t.IDPROJET === societeValue?.id), previousMonth, monthPickerValue?.year).filter(e => e.enc_supp !== 1).reduce((e, t) => e + Number(t.MONTANT || 0), 0),
        sRecouvrement: getEncaissementsFromMonth(encaissements.filter(t => t.IDPROJET === societeValue?.id), previousMonth, monthPickerValue?.year).filter(e => e.enc_supp === 1).reduce((e, t) => e + Number(t.MONTANT || 0), 0),
        sLivraison: getLivraisonsFromMonth(ventesAndAssociations.filter(t => (t.isAssLine ? t.contrat : t)?.IDPROJET === societeValue?.id), previousMonth, monthPickerValue?.year).reduce((e, t) => e + Number((t.isAssLine ? t.PRIX_VENTE : t.PRIX_NET) || 0), 0),
        // sLivraison: getLivraisonsFromMonth(ventesAndAssociations.filter(t => (t.isAssLine ? t.contrat : t)?.IDPROJET === societeValue?.id), previousMonth, monthPickerValue?.year).reduce((e, t) => e + Number((t.isAssLine ? t.contrat : t)?.PRIX_NET || 0), 0),
        goalV: budgets.find(e => e.month === previousMonth && e.year === monthPickerValue?.year && e.societeId === societeValue?.id)?.goalV,
        goalE: budgets.find(e => e.month === previousMonth && e.year === monthPickerValue?.year && e.societeId === societeValue?.id)?.goalE,
        goalR: budgets.find(e => e.month === previousMonth && e.year === monthPickerValue?.year && e.societeId === societeValue?.id)?.goalR,
        goalL: budgets.find(e => e.month === previousMonth && e.year === monthPickerValue?.year && e.societeId === societeValue?.id)?.goalL,
      }]
    }
    setTableData2(res)
  }, [societeValue, ventesAndAssociations, encaissements, budgets, monthPickerValue/*, budgetTypeValue*/])
  
  const handleSocieteChange = data => {
    setSocieteValue(data ? data.value : '');
  }
  
  const showMonthPicker = () => {
    if(monthPickerRef?.current)
      monthPickerRef.current.show()
  };

  const handlePickerChange = (year, month) => {
    setMonthPickerValue({ year, month });
    if(monthPickerRef?.current)
      monthPickerRef.current.dismiss()
  };

  const filterOptions = (e, input) => {
    if(!e.value)
      return false;
    const filterWords = input.trim().split(' ');
    
    if(filterWords.length){
      let allWordsMatch = true;
      for(let word of filterWords){
        word = word.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
        if(!e.value.LIBELE || !e.value.LIBELE.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").includes(word))
          allWordsMatch = false
      }
      return allWordsMatch
    }
    
    return true;
  }

  return loadingB || loadingG || loadingGSD ? <LoadingPage/> : (
    <>
      <Container>
        <Row className="justify-content-between">
          <Col xs="12" md="6"><h2 className="title"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Modification des budgets</h2></Col>
          <Col sm="12" md="2" className="listPageFilterTitle">
            <Label for="societe">Projet : </Label>
          </Col>
          <Col sm="12" md="4" className="listPageFilterSelect">
            <Select
              name="reactselect"
              className="reactselect"
              classNamePrefix="react-select"
              id="societe"
              value={societeValue ? {label: societeValue["LIBELE"], value: societeValue} : null}
              onChange={handleSocieteChange}
              placeholder={'Chercher par projet...'}
              isClearable={true}
              isLoading={loadingS}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={true}
              labelKey='LIBELE'
              // valueKey='code'
              options={societeOptions}
              filterOption={filterOptions}
            />
          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col xs="12" className="text-center">
            <h3 className="fullFlexCenter" style={{letterSpacing: "8px", fontFamily: "'Ultra', sans-serif", color: "darkslategray"}}>
              <MonthPicker
                ref={monthPickerRef}
                years={{min: 2010, max: 2069}}
                value={monthPickerValue}
                key={JSON.stringify(monthPickerValue)}
                lang={constants.MONTHS_ABBRV}
                onChange={handlePickerChange} >
                <div style={{cursor: "pointer"}} onClick={showMonthPicker} title="Changer la date">{constants.DP_MONTHS[monthPickerValue.month - 1]}&nbsp;{monthPickerValue.year}&nbsp;<FontAwesomeIcon icon={faCalendarAlt} /></div>
              </MonthPicker>
            </h3>
          </Col>
        </Row>
      </Container>
      {!!societeValue ? usersLoading ? <Loading /> : <GoalTable linesData={tableData} societeValue={societeValue} goals={goals} goal_societe_defaults={goal_societe_defaults} budgets={budgets} setShowUsers={setShowUsers} showUsers={showUsers} societeId={societeValue?.id} /> : null}
      {loading || loadingA || loadingE || loadingB ? <Loading /> : <>
        <Container>
          <Row>
            <Col xs="12">
              <h4><FontAwesomeIcon icon={faHistory} />&nbsp;Mois précédent</h4>
            </Col>
          </Row>
        </Container>
        <PrevMonthBudgetTable linesData={tableData2} month={monthPickerValue?.month || -1} />
      </>}
    </>
  );
};

const mapStateToProps = (state: IGoalReduxProps) => ({
  budget: state.budget,
  goal: state.goal,
  goal_societe_default: state.goal_societe_default,
  societe: state.societe,
  vente: state.vente,
  association: state.association,
  encaissement: state.encaissement,
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, { getSocietes, getGoalsByProject, clearGoals, getGoal_societe_defaults, getBudgets, getSummaryProjectBudget, clearVentes, getSummaryProjectAssociationsBudget, clearAssociations, getSummaryProjectBudgetEnc, clearEncaissements })(GoalContainerComponent);
